import React, { useState } from "react";
import {
  Typography,
  Collapse,
  IconButton,
  Card,
  CardContent,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ScrollToTopButton from "./Utilities/ScrollToTopButton";
import { Helmet } from "react-helmet-async";

const faqs = [
  {
    question: "In the case of a losing trade, is my balance or bonus deducted first?",
    answer:
      "Losses are typically deducted from your actual account balance first. Bonus funds, if applicable, are used according to specific bonus terms and conditions.",
  },
  {
    question: "What are the trading hours for cryptocurrencies?",
    answer:
      "Cryptocurrency markets are available 24/7, allowing you to trade at any time without market closing hours.",
  },
  {
    question: "Will I experience slippage when trading?",
    answer:
      "Slippage may occur during high market volatility or low liquidity conditions. However, our platform is optimized to minimize slippage as much as possible.",
  },
  {
    question: "What is the maximum leverage available?",
    answer:
      "Leverage depends on your account type and trading instrument. Higher leverage allows larger positions but also increases risk.",
  },
  {
    question: "Are spreads fixed or variable?",
    answer:
      "Spreads may vary depending on market conditions, liquidity, and the instrument being traded.",
  },
  {
    question: "Is there any commission charged on trades?",
    answer:
      "Commission structure depends on the account type. Some accounts may have zero commission with wider spreads, while others offer tighter spreads with a small fee.",
  },
  {
    question: "Can I use scalping and hedging strategies?",
    answer:
      "Yes, most trading strategies including scalping and hedging are supported, giving traders flexibility in execution.",
  },
  {
    question: "What happens if my margin level drops too low?",
    answer:
      "If your margin level falls below the required threshold, your positions may be automatically closed to prevent further losses (stop-out level).",
  },
  {
    question: "Do you provide negative balance protection?",
    answer:
      "Yes, negative balance protection ensures that you cannot lose more than your deposited funds.",
  },
  {
    question: "How is trade execution handled on the platform?",
    answer:
      "Trades are executed instantly based on real-time market prices, ensuring fast and reliable order processing.",
  },
];

const TradingConditionfaq = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
        <Helmet>
           <link rel="canonical" href="https://www.hcfinvest.com/tradingConditionfaq" />
        </Helmet>
      
      <Container sx={{ backgroundColor: "#fff" }} maxWidth={false} disableGutters>
        <ScrollToTopButton/>
      <Box
        sx={{
          position: "relative",
          height: "475px",
          display: "flex",
          flexDirection: "column", // 👈 Stack text vertically
          alignItems: "center",
          justifyContent: "center",
          color: "white",
          backgroundImage: `url('Images/HelpCenterImages/Newhedgecapitalsimage_Helpcenter 1.jpg')`, // 👈 replace with your image path
          backgroundSize: "cover",
          backgroundPosition: "center",
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        <h1
          // variant="h3"
          // component="h1"
          sx={{
            zIndex: 2,
            fontWeight: 600,
            textAlign: "center",
            px: 2,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Trading Conditions
        </h1>

        {/* <Typography
          variant="h5"
          sx={{
            zIndex: 2,
            fontWeight: 500,
            px: 2,
          }}
        >
          Choose the Right Account to Match Your Trading Style
        </Typography> */}
      </Box>

      <Typography
        variant="h2"
        sx={{
          marginBottom: "50px",
          fontWeight: "600",
          fontSize: "2.5rem",
          color: "#101828",
        }}
      >
        FAQ
      </Typography>

      <Box sx={{ maxWidth: "1200px", margin: "40px auto" }}>
        {faqs.map((faq, index) => (
          <Card
            key={index}
            sx={{
              mb: 2,
              boxShadow: 2,
              borderRadius: 2,
              backgroundColor: "#fff",
              cursor: "pointer",
            }}
            onClick={() => handleToggle(index)}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" fontWeight="bold">
                  {faq.question}
                </Typography>
                <IconButton>
                  <ExpandMoreIcon
                    sx={{
                      transform:
                        openIndex === index ? "rotate(180deg)" : "rotate(0deg)",
                      transition: "transform 0.3s ease",
                    }}
                  />
                </IconButton>
              </Box>

              <Collapse in={openIndex === index} timeout="auto" unmountOnExit>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 2,
                    color: "text.secondary",
                    lineHeight: 1.7,
                    textAlign: "left",
                  }}
                >
                  {faq.answer}
                </Typography>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
    </>
  );
};

export default TradingConditionfaq;
